module.exports = __webpack_public_path__ + "7d8ffb9e189e3b067db6f37972b0075d.MP3";